import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromEnrollment from './enrollment.reducer';

export const selectEnrollmentState =
  createFeatureSelector<fromEnrollment.EnrollmentState>(
    fromEnrollment.enrollmentFeatureKey
  );

export const selectEnrollments = createSelector(
  selectEnrollmentState,
  state => state.enrollments
);

export const selectEnrollmentById = (id: string) =>
  createSelector(selectEnrollmentState, state =>
    state.enrollments.find(enrollment => enrollment.id === id)
  );

export const selectSelectedEnrollment = createSelector(
  selectEnrollmentState,
  state => state.enrollment
);
